import React, { useEffect, useState } from 'react';
import Bet from './Bet';
import { db } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { useSearchParams } from 'react-router-dom';
import Header from './header';

function BetDetails() {
  const [bet, setBet] = useState(null);
  const { currentUser } = useAuth();
  
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');


  // Fetch friends' bets and profiles
  const fetchBet = async (id) => {
    if(!id || id === ""){
        return
    }
    if (currentUser) {
      try {
        const q2 = query(collection(db, "ActiveBets"), where("uniqueId", "==", id));
        const querySnapshot2 = await getDocs(q2);
        querySnapshot2.forEach((doc2) => {
            const betData = doc2.data();
            betData.id = doc2.id;

            var currentTime = new Date();
            var betTime = new Date(betData["bet_time"]);

            if(betData.user_id === currentUser.uid) {
              alert("This is your bet. Go to my bets and select created bets.")
              return;
            }

            if(betData["accepted"] === "Yes") {
              alert("This bet has alredy been accepeted by someone else");
              return;
            }

            if(betData["status"] !== "Created") {
              alert("Error accepting bet.");
              return;
            }

            if(betTime <= currentTime) {
              alert("This bet cannot be accepted. The event has already started!");
              return;
            }

            if(betData.user_id !== currentUser.uid && betData["accepted"] === "No" && betData["status"] === "Created" && betTime >= currentTime){
                setBet(betData);
            }
        });
      } catch (error) {
        console.error('Error fetching bets:', error);
      }
    }
  };

  useEffect(() => {
    fetchBet(id);
  }, [id]);

  const handleBetAccepted = () =>{

  }


  return (
    <div>
        <Header currentView="notifications" />
        <div className="w-full flex flex-col items-center bg-gradient-to-b from-gray-900 to-black min-h-screen mb-6">
            <div className="w-full lg:w-[60%] flex flex-col lg:flex-row">
                <div className="w-full lg:w-1/1 p-4 ">
                    {bet && <Bet key={bet.id} bet={bet} onBetAccepted={handleBetAccepted} />}
                    {!bet && <h1 className="text-white text-4xl m-5 m-[20%] w-full ">No Bet Found</h1>}
                </div>
            </div>         
        </div>
    </div>
  );
}

export default BetDetails;
